import * as io from 'socket.io-client';
import { Injectable } from '@angular/core';
import { ServerUrlService } from './server-url.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SocketService {
  socket: any
  url: string

  constructor(private serverUrl: ServerUrlService) {
    this.url = this.serverUrl.url
    this.socket = io(this.url)
  }

  emitEvent (eventName: string, data: any) {
    this.socket.emit(eventName, data)
  }

  listen (eventName: string) {
    return new Observable(subscriber => {
      this.socket.on(eventName, (data: any) => {
        subscriber.next(data)
      })
    })
  }
}
